export default __webpack_public_path__ + "static/media/bootstrap-reboot.min.css.1df84aaa.map";